import fetch from 'isomorphic-fetch'
import { serializeParams } from './utils/urlParamsUtils'

const BASE_PATH = process.env.REACT_APP_API_HOST_URL

const commonFetch = async (method, subpath, params, accessToken, options) => {
  const path = `${BASE_PATH}${subpath}`

  const response = await fetch(path, {
    method,
    // credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(accessToken ? { 'X-USER-ACCESS-TOKEN': accessToken } : {}),
      ...(options.headers ? options.headers : {}),
    },
    ...(params ? { body: JSON.stringify(params) } : {}),
  }).then((res) => res.json()).catch((err) => {
    console.log('responseStatusErrorHandler', err)
    return err
  })
  return response
}

export const get = (url, params = {}, accessToken, options = {}) => (
  commonFetch('GET', `${url}${serializeParams(params)}`, null, accessToken, options)
)

export const post = (url, params = {}, accessToken, options = {}) => (
  commonFetch('POST', url, params, accessToken, options)
)

export const put = (url, params = {}, accessToken, options = {}) => (
  commonFetch('PUT', url, params, accessToken, options)
)

export const del = (url, params = {}, accessToken, options = {}) => (
  commonFetch('DELETE', url, params, accessToken, options)
)

export default {
  get, post, put, del,
}
